import { Modal } from '@/components/ui';

export interface LeaveWithoutSavingModalProps {
  open: boolean;
  onLeave: () => void;
  onKeepEditing: () => void;
}

/**
 * Confirm modal that layers over the walkthrough's Step 1 Edit Senders
 * state when the user taps X (YAR-238 AC 10). "Leave" discards the
 * in-memory edit, closes the walkthrough, and writes `dismissed` state.
 * "Keep editing" returns to Edit Senders with all in-progress mutations
 * intact. Backdrop tap is NOT a dismiss vector here — the user must
 * pick one of the two explicit CTAs.
 */
export function LeaveWithoutSavingModal({
  open,
  onLeave,
  onKeepEditing,
}: LeaveWithoutSavingModalProps) {
  return (
    <Modal
      open={open}
      // AC 10: a backdrop tap must NOT dismiss this confirm — the user has
      // to pick one of the two explicit CTAs. Escape still routes through
      // "Keep editing" so a keyboard dismiss never loses in-progress edits.
      dismissOnBackdrop={false}
      onClose={onKeepEditing}
      bare
    >
      <div className="flex flex-col gap-4 items-center p-5">
        <div className="flex flex-col gap-1.5 w-full text-center">
          <p className="text-xl font-medium text-foreground">
            Leave without saving?
          </p>
          <p className="text-base text-foreground">
            Any changes you made to your senders won&apos;t be saved. You can
            update them anytime in Settings &gt; Approved Senders.
          </p>
        </div>
        <div className="flex flex-col gap-3 w-full">
          <button
            type="button"
            onClick={onLeave}
            className="w-full border border-danger text-danger font-semibold text-base leading-6 py-1.5 px-2 rounded-md cursor-pointer"
          >
            Leave
          </button>
          <button
            type="button"
            onClick={onKeepEditing}
            className="w-full text-muted-foreground font-semibold text-base leading-6 py-1.5 px-2 cursor-pointer"
          >
            Keep editing
          </button>
        </div>
      </div>
    </Modal>
  );
}
